import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RequirementModel } from './requisition/requirement-model';

@Injectable()
export class CarouselService {
    private _data: BehaviorSubject<RequirementModel[]> = new BehaviorSubject([]);

    public get getList(): Observable<RequirementModel[]> {
        return this._data.asObservable();
    }
    constructor() {
    }

    setList(value) {
        this._data.next(value);
    }
}